export default {
  error: {
    login: {
      en: "Fail to login",
      pt: "Falha ao logar",
    },
    sendPassword: {
      en: "Fail to send mail",
      pt: "Falha ao enviar email",
    },
  },
  info: {
    sendPassword: {
      en: "Mail whith recovery password has been sent",
      pt: "Enviado email com recuperação de senha",
    },
    correctFill: {
      en: "Check mail and password fields",
      pt: "Confira os campos de email e senha",
    },
  },
  warning: {
    correctFill: {
      sendPassword: {
        en: "Check mail field",
        pt: "Confira o email",
      },
    },
  },
};
